import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-types-new',
  templateUrl: './tickets-types.component.html',
  styleUrls: ['./tickets-types.component.scss'],
  standalone: false,
})
export class TicketsTypesComponent {
  public ticketTypes = {
    1: 'connect',
    2: 'circle-add',
    3: 'wrench',
    4: 'triangle-warning',
    5: 'doc',
  };

  @Input() ticket;

  get ticketType() {
    return this.ticket && this.ticket.ticket_type;
  }

  get isGigabyte(): boolean {
    return this.ticket && this.ticket.hd_ticket_type && this.ticket.hd_ticket_type.id === 218;
  }
}
